/* eslint-disable */
import { I18N_DIRECTION_RIGHT_TO_LEFT } from '../../../Constants/I18n/I18n.constants';
import throwParameterRequiredError from '../../../Errors/General/ParameterRequired.error';

/**
 * Determine if a given `direction` is a `rtl`
 * @export
 * @param {any} direction The direction to check
 * @returns {boolean} Whether or not `direction` is indeed `rtl`
 */
const i18nIsRtl = (direction = throwParameterRequiredError(`direction`)) => {
  return direction === I18N_DIRECTION_RIGHT_TO_LEFT;
};

export default i18nIsRtl;
